import { MsalProvider as AzureMsalProvider } from '@azure/msal-react';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig, isMsalConfigured } from '../config/msalConfig';

let msalInstance = null;

if (isMsalConfigured()) {
  msalInstance = new PublicClientApplication(msalConfig);

  msalInstance.initialize().then(() => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }

    msalInstance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
        msalInstance.setActiveAccount(event.payload.account);
      }
    });
  });
}

export const getMsalInstance = () => msalInstance;

export const MsalProviderWrapper = ({ children }) => {
  if (!msalInstance) {
    return <>{children}</>;
  }

  return (
    <AzureMsalProvider instance={msalInstance}>
      {children}
    </AzureMsalProvider>
  );
};
